<main class="main__container">
  <div class="dialog__container">
    <div class="logo-container">
      <img [src]="pdvLogo" alt="PDV LOGO" />
    </div>

    <div class="dialog__container-content content">
      <div class="content__status-icon">
        <img [src]="statusIcon" alt="Sad face icon" />
      </div>

      <section class="content__text-info">
        <h1>Vaya...</h1>
        <p>
          Parece que se ha producido un error. Inténtalo de nuevo en unos
          minutos, si necesitas ayuda ponte en contacto con nosotros a través de
          <a href="mailto:mailto:ayuda@ingood.es">ayuda@ingood.es</a>
        </p>
      </section>
    </div>
  </div>
  <app-footer></app-footer>
</main>
